services.service('FirebaseService', ['$q', '$http', 'config', 'constants', 'md5', 'ionicToast',
    function ($q, $http, config, Const, md5, ionicToast) {
        var self = this;
        var ServiceWorkerURL = '/mobile/nfp-messaging-sw.js';
        var tokenUpdateUrl = config.socket.serverAddress.replace(/^wss:/, 'https:');
        self.isEnabled = config.firebase && Object.keys(config.firebase).length > 0;

        if (!self.isEnabled) {
            console.warn('Firebase services are disabled');
            return;
        }

        this.getPermission = function (user, token, fingerprint) {
            return self.messaging.getToken()
                .then(function (fcmToken) {
                    self.fcmToken = fcmToken;
                    self.messageSubscribe(user);
                    return self.updateToken(fcmToken, token, user, fingerprint);
                })
                .catch(function (err) {
                    console.warn('Unable to get permission to notify.', err.toString());
                });
        };

        this.unregister = function () {
            if (!self.fcmToken) return;
            return self.messaging.deleteToken(self.fcmToken);
        };

        this.logEvent = function (eventName, eventParams) {
            if (!self.isEnabled) return;
            self.analytics.logEvent(eventName, eventParams);
        };

        this.setUserId = function (login) {
            if (!self.isEnabled) return;
            var userId = md5.createHash(login).toString();
            self.analytics.setUserId(userId);
        };

        this.setScreen = function (location) {
            if (!self.isEnabled) return;
            self.analytics.setCurrentScreen(location);
        };

        this.registerSW = function () {
            return navigator.serviceWorker.register(ServiceWorkerURL, {scope: '/mobile/firebase-cloud-messaging-push-scope'})
                .then(function (registration) {
                    console.warn('Registering custom service worker');
                    self.messaging.useServiceWorker(registration);
                })
                .catch(function (error) {
                    console.warn('Firebase service worker registration failed', error.toString());
                });
        };

        this.messageSubscribe = function (user) {
            self.messaging.onMessage(function (payload) {

                //show local notification
                ionicToast.show(payload.data.body, 'top', false, 5000, '');
            });
        };


        this.updateToken = function (fcmToken, token, user, fingerprint) {
            var request = {
                login: user.login,
                deviceId: fingerprint.toString(),
                token: token,
                fcmToken: fcmToken
            };
            //TODO - error handling
            return $http.post(tokenUpdateUrl + "/messaging/update", request)
        };

        try {
            firebase.initializeApp(config.firebase);
            self.messaging = firebase.messaging();
            self.analytics = firebase.analytics();
            self.registerSW();
        } catch (e) {
            console.warn('Failed to initialize firebase services', e.toString());
            self.isEnabled = false;
        }

        return this;
    }]);
